/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tools/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddParticipantAction from './AddParticipantAction/index'
import LeaveAction from './LeaveAction/index'
import React from 'react'
import SendAction from './SendAction/index'
import VirtualMeetingAction from './VirtualMeetingAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tools({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/Internal/Tools"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Tools.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-5POna': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<VirtualMeetingAction
  viewPath={`${viewPath}/VirtualMeetingAction`}
/>
<AddParticipantAction
  viewPath={`${viewPath}/AddParticipantAction`}
/>
<div
  data-testid="Tools.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-2-5POna': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<LeaveAction
  viewPath={`${viewPath}/LeaveAction`}
/>
<SendAction
  viewPath={`${viewPath}/SendAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}